import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import Header from '../Header/index';
import Main from '../Main/index';
import PopUp from '../PopUp/index';
import Hires from '../Hires/index';
import ATC from '../ATC/index';
import Footer from '../Footer/index';

import './App.scss';

class App extends React.Component {
  render() {

    return (
      <div className="App">
        <header>
          <Header />
        </header>
        <BrowserRouter>
          <Switch>
            <main>
              <Route
                exact path="/" render={() =>
                  <div className="home__container">
                    <Main />
                  </div>
                }
              />
              <Route path="/popup" component={PopUp} />
              <Route path="/hires" component={Hires} />
              <Route path="/atc" component={ATC} />
            </main>
          </Switch>
        </BrowserRouter>
        <footer>
          <Footer />
        </footer>
      </div>
    );
  }
}

export default App;
